import { MessageResponseDto } from "@api/api";
import { approveRegistrationFormDefault } from "@factory/form/form.default";
import {
  ApproveRegistrationFormRule,
  ApproveRegistrationFormSchema,
} from "@factory/form/form.rule";
import { useQyApproveRegistration } from "@factory/query/registration.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { useState } from "react";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useApproveRegistration() {
  // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapApproveRegistration } = useFormApiMapper();
  const { showError } = useNotificationContext();
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;
    navigate(`./`);
  };
  const { mutate: approveRegistration, isLoading: isCreating } =
    useQyApproveRegistration(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<ApproveRegistrationFormSchema>({
    defaultValues: approveRegistrationFormDefault,
    resolver: zodResolver(ApproveRegistrationFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: ApproveRegistrationFormSchema) => {
    const formData = mapApproveRegistration(form);
    approveRegistration(formData);
  };
  const handleValidateError = (
    err: FieldErrors<ApproveRegistrationFormSchema>
  ) => {
    const formMessage = "Please fill in required fields";
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
    showSuccessModal,
    setShowSuccessModal,
    approveRegistration,
  };
}
